export default __webpack_public_path__ + "static/media/emden.7bdc9e93.jpg";